import React from 'react';
import { Facebook, Linkedin, Twitter, Instagram } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-[#1a4d5c] text-white pt-16 pb-8 border-t border-[#2d5f6d]" data-id="element-78">
      <div className="container mx-auto px-4 md:px-6" data-id="element-79">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-80">
          {/* Brand Column */}
          <div className="col-span-1 lg:col-span-1" data-id="element-81">
            <div className="flex items-center gap-2 mb-6" data-id="element-82">
              <img src="https://cdn.magicpatterns.com/uploads/gH1zzpiYp1PqJgQJpdgZgj/Logo_PNG_Resized.png" alt="Manifold Trade Logo" className="h-20 w-auto brightness-0 invert" data-id="element-83" />
            </div>
            <p className="text-gray-300 text-sm leading-relaxed mb-6" data-id="element-84">
              Diversified trading solutions across energy, automotive, and
              mobility sectors.
            </p>
            <div className="flex space-x-4" data-id="element-85">
              <a href="#" className="text-gray-300 hover:text-[#d4a017] transition-colors" data-id="element-86">
                
              </a>
              <a href="#" className="text-gray-300 hover:text-[#d4a017] transition-colors" data-id="element-87">
                
              </a>
            </div>
          </div>

          {/* Quick Links */}
          

          {/* Services */}
          <div data-id="element-88">
            <h3 className="text-lg font-bold mb-6 text-[#d4a017]" data-id="element-89">Services</h3>
            <ul className="space-y-3" data-id="element-90">
              <li data-id="element-91">
                <a href="#" className="text-gray-300 hover:text-white transition-colors text-sm" data-id="element-92">
                  Energy Trading
                </a>
              </li>
              <li data-id="element-93">
                <a href="#" className="text-gray-300 hover:text-white transition-colors text-sm" data-id="element-94">
                  Wholesale Trade
                </a>
              </li>
              <li data-id="element-95">
                <a href="#" className="text-gray-300 hover:text-white transition-colors text-sm" data-id="element-96">
                  EV Solutions
                </a>
              </li>
              <li data-id="element-97">
                <a href="#" className="text-gray-300 hover:text-white transition-colors text-sm" data-id="element-98">
                  Automotive Parts
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div data-id="element-99">
            <h3 className="text-lg font-bold mb-6 text-[#d4a017]" data-id="element-100">Legal</h3>
            <ul className="space-y-3" data-id="element-101">
              <li data-id="element-102">
                <a href="#" className="text-gray-300 hover:text-white transition-colors text-sm" data-id="element-103">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-104">
                <a href="#" className="text-gray-300 hover:text-white transition-colors text-sm" data-id="element-105">
                  Terms of Service
                </a>
              </li>
              <li data-id="element-106">
                <a href="#" className="text-gray-300 hover:text-white transition-colors text-sm" data-id="element-107">
                  Compliance
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#2d5f6d] pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-108">
          <p className="text-gray-400 text-sm" data-id="element-109">
            &copy; {currentYear} Manifold Trade. All rights reserved.
          </p>
          <p className="text-gray-500 text-xs" data-id="element-110">
            Energy, Automotive & Mobility Solutions
          </p>
        </div>
      </div>
    </footer>;
}